import { createSelector } from '@ngrx/store';

export const getCommercialLicenseMappingsState = createSelector(
    (state: any) => state.commercialLicenseMappings,
    (state: any) => state.get('list')
);

export const getCreateCommercialLicenseMappingState = createSelector(
    (state: any) => state.commercialLicenseMappings,
    (state: any) => state.get('createCommercialLicenseMapping')
);

export const getUpdateCommercialLicenseMappingState = createSelector(
    (state: any) => state.commercialLicenseMappings,
    (state: any) => state.get('updateCommercialLicenseMapping')
);
